import logo from './logo.svg';
import './App.css';
import {BrowserRouter, Outlet, Route, Routes, useNavigate} from "react-router-dom";
import Header from "./components/topdownElements/Header";
import Footer from "./components/topdownElements/Footer";
import Home from "./components/Pages/Home/home";
import Categories from "./components/Pages/Categories/categories";
import Products from "./components/Pages/Products/products";
import About from "./components/Pages/About/about";
import Contact from "./components/Pages/Contact/contact";
import "./index.css";
import ShopingCard from "./components/Pages/Order/shopingCard";
import ProductPage from "./components/Pages/Products/ProductElements/productPage";
import OrderPage from "./components/Pages/Order/orderPage";
import SpecialOrder from "./components/Pages/SpecialOrder/specialOrder";
import Terms from "./components/Pages/TermsOfUse/terms";
import {useEffect, useState} from "react";
import CookieNotice from "./components/Pages/cookieNotice";
import PaymentContainer from "./components/payments/paymentContainer";
import HomeAdmin from "./components/AdminPages/HomeAdmin/homeAdmin";
import Dashboard from "./components/AdminPages/HomeAdmin/dashborad";
import AdminH from "./components/AdminPages/topDownAdmin/adminH";
import CategoriesAd from "./components/AdminPages/HomeAdmin/adminContainers/categoriesAdmin/categoriesAd";
import ProductsAd from "./components/AdminPages/HomeAdmin/adminContainers/productAdmin/productsAd";
import ColorsAd from "./components/AdminPages/HomeAdmin/adminContainers/colorsAdmin/colorsAd";
import DeliveriesAd from "./components/AdminPages/HomeAdmin/adminContainers/deliveries/deliveriesAd";
import OrdersAdmin from "./components/AdminPages/HomeAdmin/adminContainers/orders/ordersAdmin";
import Settings from "./components/AdminPages/HomeAdmin/adminContainers/settings";
import Statistics from "./components/AdminPages/HomeAdmin/adminContainers/statistics";
import DashContainer from "./components/AdminPages/HomeAdmin/adminContainers/dashboardContainer/dashContainer";
import {useSelector} from "react-redux";
import PayError from "./components/payments/PayError";

const COOKIE_KEY = "rotheras_cookie_ok_v1";

function App() {


    const [cookieOk, setCookieOk] = useState(true); // default true για να μην κάνει flash
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const ok = localStorage.getItem(COOKIE_KEY) === "true";
        setCookieOk(ok);
        setReady(true);
    }, []);

    if (!ready) return null;

    function PublicLayout() {
        return (
            <>
                <Header />
                <Outlet />
                <Footer />
            </>
        );
    }

    function AdminLayout() {
       /* const isLoggedIn = useSelector((state)=> state.userreducer.isLoggedIn);
        const navigate = useNavigate();

        if(!isLoggedIn) {
            navigate("/admin");
        }*/

        return (
            <>
                {/* Βάλε εδώ AdminHeader / Sidebar / whatever */}
                {/* π.χ. <AdminHeader /> ή <AdminShell /> */}
                {/*<AdminH/>*/}
                <Outlet />
                {/* Αν θες admin footer, βάλε το εδώ */}
            </>
        );
    }

    return (
      <div className="App">

        <BrowserRouter>
            <CookieNotice
                open={!cookieOk}
                onOk={() => {
                    localStorage.setItem(COOKIE_KEY, "true");
                    setCookieOk(true);
                }}
            />

          <Routes>
              <Route element={<PublicLayout/>} >
            <Route path="/" element={<Home />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/products/:page" element={<Products />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:categoryId/:page?" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
              <Route path="/shopingcard" element={<ShopingCard />} />
              <Route path="/products/productpage/:productId" element={<ProductPage />} />
              <Route path="/order" element={<OrderPage />} />
              <Route path="/specialorder" element={<SpecialOrder />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/checkout/success" element={<PaymentContainer />} />
                  <Route path="/checkout/error" element={<PayError />}/>
                  <Route path="/admin" element={<HomeAdmin />} />
              </Route>
              {/*<Route element={<AdminLayout />} >*/}
                <Route path="/admin/*" element={<Dashboard />} >
                    <Route path="home" element={<DashContainer />} />
                    <Route path="categoriesAd" element={<CategoriesAd />} />
                    <Route path="productsAd" element={<ProductsAd />} />
                    <Route path="colorsAd" element={<ColorsAd />}/>
                    <Route path="ordersAd" element={<OrdersAdmin/>} />
                    <Route path="deliveriesAd" element={<DeliveriesAd/>} />
                    <Route path="statistics" element={<Statistics/>} />
                    <Route path="settings" element={<Settings/>} />
                </Route>
             {/* </Route>*/}
          </Routes>
        </BrowserRouter>


      </div>
  );
}

export default App;
